export default __webpack_public_path__ + "static/media/f_footer.1bef9a1b.svg";